webpackJsonp([70144966829960],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _myTitle = __webpack_require__(12);
	
	var _myTitle2 = _interopRequireDefault(_myTitle);
	
	var _blockCover = __webpack_require__(17);
	
	var _blockCover2 = _interopRequireDefault(_blockCover);
	
	var _contact = __webpack_require__(57);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _reactstrap = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        '\xC9beniste, menuisier en \xEEle de france, Paris'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'D\xE9couvrons ensemble les meilleurs solutions pour vos am\xE9nagements sur mesure int\xE9rieurs et ext\xE9rieurs.' })
	    ),
	    _react2.default.createElement(_blockCover2.default, {
	      backgroundUrl: _contact2.default,
	      title: 'Contact',
	      repeatedTitle: true }),
	    _react2.default.createElement(
	      'div',
	      { className: 'decoration' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row no-gutters' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 contact-background' },
	          _react2.default.createElement(
	            _block2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row justify-content-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-7' },
	                _react2.default.createElement(
	                  _myTitle2.default,
	                  null,
	                  'Contactez-nous'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Form,
	                  { method: 'post', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field', name: 'contact' },
	                  _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      'Don\u2019t fill this out: ',
	                      _react2.default.createElement('input', { name: 'bot-field' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Input,
	                      { type: 'select', defaultValue: '', name: 'type', id: 'type' },
	                      _react2.default.createElement(
	                        'option',
	                        { disabled: true, value: '' },
	                        'Vous \xEAtes\u2026'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'monsieur' },
	                        'Monsieur'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'madame' },
	                        'Madame'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'name', id: 'name', placeholder: 'Nom, pr\xE9nom' })
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(_reactstrap.Input, { type: 'email', name: 'email', id: 'email', placeholder: 'Adresse email' })
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.FormGroup,
	                    null,
	                    _react2.default.createElement(_reactstrap.Input, { type: 'textarea', rows: '4', name: 'message', id: 'message', placeholder: 'Votre message' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'text-align-center' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', className: 'btn btn-primary btn-big btn-min-width-300 mt-3' },
	                      'Envoyer'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-white contact-item-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'contact-item' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'mb-0 fs-27 color-red light lh-32' },
	                    'Didier ',
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Br\xE9'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-15 color-red bold uppercase lh-19', style: {
	                        letterSpacing: '2px'
	                      } },
	                    'Showroom'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-16 lh-23' },
	                    '17 Avenue d\'Argenteuil',
	                    _react2.default.createElement('br', null),
	                    '92600 Asni\xE8res-sur-Seine'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-16 lh-23 light' },
	                    'Horaires sur rendez-vous :\u2028',
	                    _react2.default.createElement('br', null),
	                    'de 9h00 \xE0 12h00\u2028',
	                    _react2.default.createElement('br', null),
	                    'de 14h00 \xE0 18h00'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'contact-item' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'mb-0 fs-27 color-red light lh-32' },
	                    'Didier ',
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Br\xE9'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-15 color-red bold uppercase lh-19', style: {
	                        letterSpacing: '2px'
	                      } },
	                    'Atelier de fabrication'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-16 lh-23' },
	                    '1 bis, av. du Capitaine Thuilleaux\u2028',
	                    _react2.default.createElement('br', null),
	                    '78170 La-Celle-Saint-Cloud'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'fs-16 lh-23 light' },
	                    'T\xE9l\xE9phone : 06 07 67 36 16\u2028',
	                    _react2.default.createElement('br', null),
	                    'Fax : 01 40 80 08 43',
	                    _react2.default.createElement('br', null),
	                    '\u2028contact@menuiseriebre.fr'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'map-container embed-responsive' },
	            _react2.default.createElement('iframe', { className: 'embed-responsive-item', src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d655.5599366009526!2d2.2850217594424143!3d48.91082436660609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66f63a223d18b%3A0x935be1d3a0b639c5!2s17+Avenue+d\'Argenteuil%2C+92600+Asni%C3%A8res-sur-Seine!5e0!3m2!1sen!2sfr!4v1511172999944', width: '800', height: '600', frameBorder: '0', style: {
	                border: 0
	              }, allowFullScreen: true })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-b212988e5b370df847bf.js